import Icon from '../../../components/AppIcon';
import { ContributionStats } from '../types';

interface StatsOverviewProps {
  stats: ContributionStats;
}

const StatsOverview = ({ stats }: StatsOverviewProps) => {
  const formatCurrency = (amount: number) => {
    return `${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} VT`;
  };

  const formatPercentage = (value: number) => {
    return `${Math.round(value)}%`;
  };

  const statCards = [
    {
      label: 'Total Contributions',
      value: stats.totalContributions.toString(),
      icon: 'Hash',
      color: 'var(--color-primary)',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Total Amount',
      value: formatCurrency(stats.totalAmount),
      icon: 'DollarSign',
      color: 'var(--color-success)',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Average Amount',
      value: formatCurrency(stats.averageAmount),
      icon: 'TrendingUp',
      color: 'var(--color-accent)',
      bgColor: 'bg-accent/10'
    },
    {
      label: 'Participation Rate',
      value: formatPercentage(stats.participationRate),
      icon: 'Target',
      color: 'var(--color-warning)',
      bgColor: 'bg-warning/10'
    },
    {
      label: 'Current Streak',
      value: `${stats.currentStreak} days`,
      icon: 'Flame',
      color: 'var(--color-error)',
      bgColor: 'bg-error/10'
    },
    {
      label: 'Longest Streak',
      value: `${stats.longestStreak} days`,
      icon: 'Award',
      color: 'var(--color-secondary)',
      bgColor: 'bg-secondary/10'
    }
  ];

  return (
    <div className="bg-card rounded-md border border-border p-6 shadow-elevation-1">
      <h2 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
        <Icon name="BarChart3" size={20} />
        Contribution Statistics
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {statCards.map((stat, index) => (
          <div
            key={index}
            className="p-4 bg-muted rounded-sm transition-interactive hover-scale"
          >
            <div className="flex items-start justify-between mb-3">
              <div className={`w-10 h-10 rounded-full ${stat.bgColor} flex items-center justify-center`}>
                <Icon name={stat.icon} size={20} color={stat.color} />
              </div>
            </div>
            <div className="text-2xl font-semibold text-foreground mb-1">
              {stat.value}
            </div>
            <div className="text-sm text-muted-foreground">
              {stat.label}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-primary/5 rounded-sm border border-primary/20">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
          <div className="text-sm text-foreground">
            <p className="font-medium mb-1">Participation Rate Calculation</p>
            <p className="text-muted-foreground">
              Based on contributions made versus total scheduled contribution days since joining the group.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsOverview;